import { Skeleton } from "@/components/atoms/Skeleton";

export type FsvPriceFeeCalcSkeletonProps = {
  isDepositListing: boolean;
};

/**
 * Matches the line heights of the loaded FSV header so the booking card
 * doesn't change height when the estimate or quote arrives:
 * "Due today" (body-1), price (headline-5-b), then one detail line for
 * deposit listings or two for minimum-spend listings (body-1).
 */
export const FsvPriceFeeCalcSkeleton = ({
  isDepositListing,
}: FsvPriceFeeCalcSkeletonProps) => {
  return (
    <div
      className="tw-flex tw-flex-col tw-items-center tw-gap-4"
      data-testid="fsv-book-listing-card-header-skeleton"
    >
      <Skeleton height={16} width={72} />
      <Skeleton height={40} width={144} />
      <Skeleton height={16} width={200} />
      {!isDepositListing && <Skeleton height={16} width={240} />}
    </div>
  );
};
